import { render, staticRenderFns } from "./ExcelDropdownOptionItem.vue?vue&type=template&id=31983eb2&"
import script from "./ExcelDropdownOptionItem.vue?vue&type=script&lang=js&"
export * from "./ExcelDropdownOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcelDropdownOptionItem.vue?vue&type=style&index=0&id=31983eb2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports